import React, { FC, ReactElement } from 'react'
import { Provider } from 'react-redux'
import { store } from '../../store'

export const AdminNotariesBoard: FC<{}> = (): ReactElement => {
  return <Provider store={store}></Provider>
}
